import { render, staticRenderFns } from "./export-assignments.vue?vue&type=template&id=0f64a972"
import script from "./export-assignments.vue?vue&type=script&lang=js"
export * from "./export-assignments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports